import script from "./PackagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PackagePreview.vue?vue&type=script&setup=true&lang=js"

import "./PackagePreview.vue?vue&type=style&index=0&id=b5ac6908&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ac6908"]])

export default __exports__